import {ExtractDeliveryNoteDocumentMessageInput} from '@prompt-bridge/shared/validations';

import {DocumentExtractionMode} from '../types/DocumentExtractionMode';

/** The single place that decides how an extracted document is reviewed. */
export function getDocumentExtractionMode(
  input: ExtractDeliveryNoteDocumentMessageInput | null
): DocumentExtractionMode {
  return input?.sourceFormat === 'NISSAN_DIGLAS' ? 'structuredInvoice' : 'aiExtraction';
}
